import { Routes, Route } from "react-router-dom";
import { RegionalSubstitutionList } from "./list";
import { CreateRegionalSubstitution } from "./create";
import { EditRegionalSubstitution } from "./edit";

export default function RegionalSubstitutionRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RegionalSubstitutionList />} />
      <Route path="/criar" element={<CreateRegionalSubstitution />} />
      <Route path="/editar/:id" element={<EditRegionalSubstitution />} />
    </Routes>
  );
}
